import { onMounted, watch } from 'vue'
import { useAnalyticsConfig } from './useAnalyticsConfig'
import { useKlaroConsent } from './useKlaroConsent'

export function useMetaPixelLoader() {
  const { shouldLoadGoogleAnalytics } = useAnalyticsConfig()
  const { hasMetaPixelConsent } = useKlaroConsent()

  const loadMetaPixelScripts = () => {
    if (!shouldLoadGoogleAnalytics.value) {
      return
    }

    if (!hasMetaPixelConsent()) {
      return
    }

    // Sprawdź czy skrypty już istnieją
    const existingScripts = document.querySelectorAll('script[data-name="meta-pixel"]')
    if (existingScripts.length > 0) {
      // Jeśli skrypty istnieją, ale fbq nie jest dostępny, usuń je i załaduj ponownie
      if (!window.fbq) {
        existingScripts.forEach(script => script.remove())
      } else {
        return // Skrypty już działają
      }
    }

    // Dodaj Meta Pixel script
    const metaPixelScript = document.createElement('script')
    metaPixelScript.type = 'text/javascript'
    metaPixelScript.setAttribute('data-name', 'meta-pixel')
    metaPixelScript.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1835058007440703');
      fbq('track', 'PageView');
    `
    document.head.appendChild(metaPixelScript)

    // Dodaj noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = '1'
    img.width = '1'
    img.style.display = 'none'
    img.src = 'https://www.facebook.com/tr?id=1835058007440703&ev=PageView&noscript=1'
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  // Funkcja do sprawdzenia czy fbq jest dostępny
  const checkFbqAvailability = () => {
    return typeof window !== 'undefined' && window.fbq
  }

  // Usuń skrypty Meta Pixel
  const removeMetaPixelScripts = () => {
    const scripts = document.querySelectorAll('script[data-name="meta-pixel"]')
    scripts.forEach(script => script.remove())
    
    // Usuń noscript fallback
    const noscripts = document.querySelectorAll('noscript')
    noscripts.forEach(noscript => {
      const img = noscript.querySelector('img[src*="facebook.com/tr"]')
      if (img) {
        noscript.remove()
      }
    })
    
    // Usuń fbq z window
    if (window.fbq) {
      delete window.fbq
    }
    if (window._fbq) {
      delete window._fbq
    }
  }

  // Nasłuchuj zmian zgody w Klaro
  const setupKlaroConsentListener = () => {
    if (!window.klaro) {
      return
    }

    // Nasłuchuj na zdarzenia Klaro
    window.addEventListener('klaro:consent', (event) => {
      const { services } = event.detail
      
      if (services['meta-pixel']) {
        // Użytkownik wyraził zgodę na Meta Pixel
        setTimeout(() => {
          loadMetaPixelScripts()
        }, 100)
      } else {
        // Użytkownik odwołał zgodę na Meta Pixel
        removeMetaPixelScripts()
      }
    })

    // Nasłuchuj na zdarzenie gotowości Klaro
    window.addEventListener('klaro:ready', () => {
      const manager = window.klaro.getManager()
      if (manager.consents['meta-pixel'] && shouldLoadGoogleAnalytics.value) {
        setTimeout(() => {
          loadMetaPixelScripts()
        }, 100)
      }
    })
  }

  // Sprawdź i załaduj skrypty
  const checkAndLoadScripts = () => {
    const hasConsent = hasMetaPixelConsent()
    const shouldLoad = shouldLoadGoogleAnalytics.value
    
    if (hasConsent && shouldLoad) {
      loadMetaPixelScripts()
    } else {
      removeMetaPixelScripts()
    }
  }

  onMounted(() => {
    // Sprawdź zapisaną zgodę natychmiast
    checkAndLoadScripts()
    
    // Ustaw nasłuchiwanie na zmiany zgody
    setupKlaroConsentListener()
  })

  return {
    loadMetaPixelScripts,
    checkFbqAvailability,
    removeMetaPixelScripts,
    checkAndLoadScripts
  }
}
